var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"SkeletonBox",style:({ height: _vm.height, width: _vm.computedWidth, 'border-radius': _vm.computedRadius })})}
var staticRenderFns = []

export { render, staticRenderFns }